<template>
  <div class="info-box">
    <div class="info-grid">
      <div>
        <h3>
          <i class="icofont-info-circle"></i>
          Critérios de Classificação e Desempate Aplicados:
        </h3>

        <ol>
          <li>
            <strong>% Regular (Componentes)</strong>
            (Ordem Crescente - Critério 1: Fase superada por todas as equipes.
            0% lidera).
          </li>
          <li>
            <strong>% Suficiente (Componentes)</strong>
            (Ordem Crescente - Critério 2: Superação de etapa. Menor percentual
            lidera).
          </li>
          <li>
            <strong>Desempenho (Componentes)</strong>
            (Ordem Decrescente - Critério 3: Maior Índice calculado por pesos).
          </li>
          <li>
            <strong>% Ótimo (Componentes)</strong>
            (Ordem Decrescente - Critério 4: Excelência das equipes. Maior
            percentual lidera).
          </li>
          <li>
            <strong>% Bom (Componentes)</strong>
            (Ordem Decrescente - Critério 5: Maior percentual lidera).
          </li>
          <li>
            <strong>Média de Indicadores</strong>
            (Ordem Decrescente - Critério 6: Persistindo o empate, vence a maior
            Média de Indicadores).
          </li>
          <li>
            <strong>IED</strong>
            (Ordem Crescente - Critério 7: Menor valor lidera).
          </li>
          <li>
            <strong>Total de Equipes Avaliadas</strong>
            (Ordem Decrescente - Critério 8: Premia redes maiores, com mais
            equipes avaliadas no quadrimestre).
          </li>

          <li>
            <strong>População</strong>
            (Ordem Decrescente - Critério 9: Desempate final. Municípios mais
            populosos lideram).
          </li>
        </ol>
      </div>

      <div class="formula-box">
        <h3>
          <i class="icofont-calculator-alt-2"></i>
          Fórmulas de Cálculo:
        </h3>

        <div class="formula-content">
          <div class="formula-item">
            <strong>1. Coluna COMPONENTES (Índice de Desempenho):</strong>

            <div class="formula-code formula-code-componentes">
              [ (ÓTIMO×4) + (BOM×3) + (SUFICIENTE×2) + (REGULAR×1) ] /
              (TOTAL_EQUIPES × 4) * 100
            </div>
          </div>

          <div class="formula-item">
            <strong class="formula-title-indicadores">
              2. Coluna INDICADORES (Média Geral):
            </strong>

            <div class="formula-description">
              Calcula-se o desempenho individual de cada indicador
              <em>(usando a mesma fórmula de pesos acima)</em> e extrai-se a
              média aritmética simples do município:
            </div>

            <div class="formula-code formula-code-indicadores">
              Σ (Desempenho de cada Indicador) / (Quantidade Total de
              Indicadores)
            </div>
          </div>
        </div>
      </div>
    </div>

    <p class="note">
      <strong>
        Clique nos 3 pontinhos (<i class="icofont-navigation-menu"></i>)
      </strong>
      ao lado do município para abrir o modal de detalhamento avançado.
    </p>

    <p class="mb-0">
      <strong>Fonte</strong>:
      <a href="https://siaps.saude.gov.br/publico" target="_blank">Siaps</a>,
      jun. 2026.
    </p>
  </div>
</template>

<script>
export default {
  name: 'RankingInfoBox',

  props: {
    info: {
      type: Object,
      default: () => ({
        type: '',
        title: '',
      }),
    },
  },
}
</script>

<style scoped>
.info-box {
  background: #eff6ff;
  border: 1px solid #dbeafe;
  color: #1e40af;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 20px;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  min-width: 0;
}

.info-grid > div {
  min-width: 0;
}

h3 {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 8px;
  color: #1e3a8a;
  font-size: 15px;
  font-weight: 800;
}

h3 i {
  color: #2563eb;
}

ol {
  margin: 0;
  padding-left: 20px;
  font-size: 12px;
}

li {
  margin-bottom: 6px;
  line-height: 1.5;
}

li strong {
  color: #1e3a8a;
}

.formula-box {
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 12px;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.04);
}

.formula-box h3 {
  color: #312e81;
  margin-bottom: 12px;
}

.formula-box h3 i {
  color: #4f46e5;
}

.formula-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #374151;
  font-size: 12px;
}

.formula-item strong {
  display: block;
  color: #4338ca;
  margin-bottom: 4px;
}

.formula-title-indicadores {
  color: #7e22ce !important;
}

.formula-description {
  margin-bottom: 4px;
  color: #4b5563;
}

.formula-code {
  font-family: monospace;
  padding: 8px;
  border-radius: 6px;
  overflow-x: auto;
  white-space: nowrap;
}

.formula-code-componentes {
  background: #eef2ff;
  color: #3730a3;
  border: 1px solid #e0e7ff;
}

.formula-code-indicadores {
  background: #faf5ff;
  color: #6b21a8;
  border: 1px solid #f3e8ff;
}

.note {
  display: block;
  margin: 14px 0 0;
  padding-top: 12px;
  border-top: 1px solid rgba(191, 219, 254, 0.7);
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
}

.note i {
  color: #2563eb;
}

.note strong {
  color: #1e40af;
}

@media (min-width: 992px) {
  .info-grid {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
